import axios from "axios";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL + "/api" });

api.interceptors.request.use(cfg => {
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");
  if (token) cfg.headers.Authorization = "Bearer " + token;
  return cfg;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      // Don't redirect if we're already on an auth page — let the page handle its own errors
      const isAuthPage = ["/login", "/admin-login", "/register", "/admin-register"].includes(path)
        || path.startsWith("/forgot-password")
        || path.startsWith("/reset-password/")
        || path.startsWith("/verify-email/");
      if (!isAuthPage) {
        const isAdmin = !!sessionStorage.getItem("token");
        sessionStorage.removeItem("token"); sessionStorage.removeItem("user");
        localStorage.removeItem("token");  localStorage.removeItem("user");
        // Preserve current page so user returns here after login
        const redirectTo = window.location.pathname + window.location.search;
        window.location.href = isAdmin
          ? "/admin-login"
          : `/login?redirect=${encodeURIComponent(redirectTo)}`;
      }
    }
    return Promise.reject(err);
  }
);

export default api;